import { LayoutGrid } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { EmptyState, PageHeader } from '@/components/ui';
import { isInfraView } from '../../model';
import { Body, Page } from '../common';
import { NotFoundScreen } from '../StateScreens';
import { InfraManage } from './InfraManage';
import { InfraNodes } from './InfraNodes';
import { InfraOverview } from './InfraOverview';
import { InfraProblems } from './InfraProblems';

/** Виды приложения-образца по пункту третьего уровня. */
export function InfraScreen() {
  const key = useParams()['*'] || 'overview';
  if (key === 'overview') return <InfraOverview />;
  if (key === 'problems') return <InfraProblems />;
  if (key === 'unacked') return <InfraProblems preset="unacked" />;
  if (key === 'night' || key === 'dc-2') return <InfraProblems preset="high" />;
  if (key === 'nodes') return <InfraNodes />;
  if (key.startsWith('manage-')) return <InfraManage view={key} />;
  // Такого вида у приложения нет — «не найдено» в той же вкладке, меню приложения остаётся (R42).
  if (!isInfraView(key)) return <NotFoundScreen />;
  return (
    <Page>
      <PageHeader title={key === 'vms' ? 'Виртуальные машины' : 'Группы'} />
      <Body>
        <EmptyState
          icon={<LayoutGrid />}
          title="Этот вид в образце не нарисован"
          description="Меню, вкладки и переходы работают; экран появится вместе с настоящим приложением."
        />
      </Body>
    </Page>
  );
}
